import { render } from "./ModalUserNotifications.vue?vue&type=template&id=6b4c3e2f"
import script from "./ModalUserNotifications.vue?vue&type=script&lang=js"
export * from "./ModalUserNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Projects/webshop/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__